import { atom } from 'recoil';
import { MobileCampaign } from '@/mobile/types/api/mypage/campaign';

// キャンペーンとキャッシュバックを同じ state にまとめ、表示判定を一箇所で行えるようにする。
export const mobileCampaignState = atom<MobileCampaign>({
  key: 'mobileCampaignState',
  default: {
    cashbacks: [],
    campaigns: [],
  },
});

export default mobileCampaignState;
